// import { initColorMode } from "./theme/colorMode"; // TODO: activate Darkmode

import changeEventForInput from "./helper/autofill-events";
import vanillaJSdocumentReadyHelper from "./helper/document-ready-helper";
import animateContentOnScroll from "./helper/animate-content-on-scroll";

import { scrollToID } from "./helper/helper";
import {
  initToggleDropdown,
  disableEmptyNavLinks,
  initToggleCloseSubmenus,
} from "./partials/mb-navigation";
import { initNavIcon } from "./partials/mb-nav-icon";
import { initSearchform } from "./partials/mb-searchform";
import { initMbModal } from "./partials/mb-modal";
import { configLibraries } from "./theme/configLibraries";
import { linkWrapperClickHandler, initWatchHover } from "./theme/clickHandler";
import { initReadmore, updateReadMore } from "./partials/mb-readmore";
import { initProductsSlider } from "./partials/mb-single-mb-products";
// import { mbYoutubeBorlabsGate } from "./partials/mb-youtube-borlabs-gate";
import { initWorkshopLogin } from "./partials/mb-workshop-login";
import { initJobSelect } from "./partials/add-jobs-to-jobselect";
// import { checkOpeningHoursStatus } from "./partials/mb-opening-hours";

import { printDeveloperMessageToConsole } from "./helper/mbagentur";

import { cf7MailSentHandler } from "./partials/mb-cf7MailSentHandler";

/**
 * Init JS Helper
 */
vanillaJSdocumentReadyHelper();
changeEventForInput();

(function () {
  function init() {
    // // Get styling informations from css property values
    // const style = getComputedStyle(document.body);
    // const max_mainwidth = style.getPropertyValue("--maxMainWidth");

    // // TODO: activate Darkmode
    // initColorMode();

    initNavIcon();
    initSearchform();
    initToggleDropdown();
    disableEmptyNavLinks();
    configLibraries();
    linkWrapperClickHandler();
    initWatchHover();
    animateContentOnScroll();
    initMbModal();
    initReadmore();
    initToggleCloseSubmenus();
    // mbYoutubeBorlabsGate();
    initProductsSlider();
    initWorkshopLogin();
    initJobSelect();

    // check & update opening hours
    // checkOpeningHoursStatus();
    // setInterval(checkOpeningHoursStatus, 60000);

    printDeveloperMessageToConsole();

    cf7MailSentHandler(".wpcf7-form");
  }

  init();

  // On document ready
  docReady(function (context) {});
})();

/**
 * Remove page loader
 */
jQuery(window).on("load", function () {
  jQuery(".mb-loader-wrapper").fadeOut("slow", function () {
    jQuery(this).remove();
    document.body.setAttribute("aria-live", "assertive");
  });
});

/**
 * Smooth Anker scrolling
 */
jQuery('a[href*="#"]').on("click", function (e) {
  const target = this.hash;
  if (scrollToID(target, -100)) {
    e.preventDefault();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let current_url = window.location.href;
  let current_hash = window.location.hash;

  if (current_hash.length > 0) {
    // prevent page jump on load
    window.location.hash = "";

    var target = current_hash;
    var $target = jQuery(target);
    var targetArray = Array.from(jQuery(target));

    setTimeout(function () {
      jQuery("html, body")
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top - 100,
          },
          900,
          "swing",
          function () {
            // window.location.hash = target;
          }
        );
    }, 1500);
  }
});

/**
 * Document resize listener
 */
window.addEventListener("resize", (event) => {
  updateReadMore();
});

/**
 * Scroll top button
 */
let topbtn = document.getElementById("topbutton");

window.addEventListener("scroll", function () {
  if (window.scrollY > 300 && topbtn) {
    topbtn.classList.add("show");
  } else if (topbtn) {
    topbtn.classList.remove("show");
  }
});

topbtn.addEventListener("click", function (e) {
  e.preventDefault();
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

// scrolling detection for main menu
jQuery(window).scroll(function () {
  var scroll = jQuery(window).scrollTop();

  if (scroll >= 1) {
    jQuery("#mb-section-main-menu").addClass("scrolling");
  } else {
    jQuery("#mb-section-main-menu").removeClass("scrolling");
  }
});

// accessibility
document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    if (document.activeElement && document.activeElement !== document.body) {
      document.activeElement.blur();
    }
  }
});
